<script setup lang="ts">
import Card from '../components/Card.vue';
import ChangeCognitoEmail from '../components/Forms/ChangeCognitoEmail.vue';
import EmailForm from '../components/Forms/EmailForm.vue';
import PasswordForm from '../components/Forms/PasswordForm.vue';
import DeleteAccount from '../components/DeleteAccount.vue';
import { isCognitoEnabled } from '@/shared/auth/cognitoFeatureFlag';
import { usePasswordRecovery } from '@/shared/auth/usePasswordRecovery';
const recoveryAvailable = usePasswordRecovery(isCognitoEnabled);
</script>

<template>
  <div>
    <template v-if="isCognitoEnabled">
      <Card title="Change Email" noFooter>
        <ChangeCognitoEmail />
      </Card>
      <Card v-if="recoveryAvailable" title="Change Password" noFooter>
        <PasswordForm />
      </Card>
    </template>

    <template v-else>
      <Card title="Change Email" noFooter>
        <EmailForm />
      </Card>

      <Card title="Change Password" noFooter>
        <PasswordForm />
      </Card>

      <Card title="Delete Account" noFooter>
        <DeleteAccount />
      </Card>
    </template>
  </div>
</template>

<style scoped></style>
